import { render, staticRenderFns } from "./PlainLayout.vue?vue&type=template&id=f9d1e892"
import script from "./PlainLayout.vue?vue&type=script&lang=js"
export * from "./PlainLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports